<template>
  <div class="form-item-container">
    <div class="questions-container">
      <div class="question-primary-language">
        {{ question_lang1 }}
      </div>
      <div class="question-secondary-language" v-if="bilingue">
        {{ question_lang2 }}
      </div>
    </div>
    <div class="references-container">
      <div v-for="(option, index) in options" :key="index" class="reference">
        <span class="reference-primary-language">{{ option.text_lang1 }}</span>
        <span class="reference-secondary-language" v-if="bilingue">{{ option.text_lang2 }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { FormItemOption } from '@/utils/DataTypes'

export default {
  name: 'NavigationItem',
  props: {
    question_lang1: {
      type: String,
      default: ''
    },
    question_lang2: {
      type: String,
      default: ''
    },
    bilingue: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array as () => Array<FormItemOption>,
      default: () => []
    },
    form_item_id: {
      type: Number,
      default: 0
    },
    form_item_order: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.form-item-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;

  padding: 2em 5% 2em 5%;

  color: white;

  .questions-container {
    grid-row: 1;

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;

    align-items: center;
    justify-items: center;

    padding-bottom: 2em;

    .question-primary-language {
      grid-row: 1;
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
    }

    .question-secondary-language {
      grid-row: 2;
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
    }
  }

  .references-container {
    grid-row: 2;
    display: grid;
    gap: 1em;
    grid-template-columns: 1fr;

    align-items: center;
    justify-content: center;

    .reference {

      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr auto;

      text-align: center;

      max-width: 100%;
      max-height: 30em;

      padding: 1em;

      background-color: rgba(255, 255, 255, 0.12);

      border: solid 1px #979797;
      border-radius: 10px;

      cursor: pointer;

      .reference-primary-language {
        grid-row: 1;
        font-size: clamp(1.4em, 0.9vw + 1rem, 1.9em);
        padding-bottom: 0.2em;
      }

      .reference-secondary-language {
        grid-row: 2;
        font-size: clamp(1.2em, 0.8vw + 1rem, 1.5em);
      }
    }

    .clicked {
      border-color: white;
      background-color: #f0f0f0;
      color: black;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
